import { updateExtractionPoint } from "@services/extractionPoints";
import { useMutation } from "@tanstack/react-query";

export const useUpdateExtractionPoint = (options: any = {}) => {
  return useMutation(updateExtractionPoint, options);
};
